exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/icon/mobile/svg/anonymous_outline_regular_24.svg"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("@tencent/docs-design-resources/pc/svg/template_beta_16.svg"));

// Module
exports.push([module.id, ".style-menu-anonymous-switch-mobile-_fs2S{background-image:url(" + ___CSS_LOADER_URL___0___ + ")}.style-anonymous-view-menu-2h2p1{display:flex;flex-direction:row;align-items:center}.style-anonymous-view-menu-2h2p1 .style-main-title-2FN3F{height:14px;line-height:14px}.style-anonymous-view-menu-2h2p1 .style-beta-tag-2gbsy{margin-left:4px;width:32px;height:16px;background-size:32px 16px;background-image:url(" + ___CSS_LOADER_URL___1___ + ")}", ""]);

// Exports
exports.locals = {
	"menu-anonymous-switch-mobile": "style-menu-anonymous-switch-mobile-_fs2S",
	"anonymous-view-menu": "style-anonymous-view-menu-2h2p1",
	"main-title": "style-main-title-2FN3F",
	"beta-tag": "style-beta-tag-2gbsy"
};